import React from "react";
import { Dashboard } from "app/pages/Dashboard";
import { MobileOrdersPage } from "app/mobile/pages/MobileOrdersPage";
import { useMobileLayout } from "app/hooks/useMobileLayout";

export function ResponsiveOrdersPage() {
  const isMobile = useMobileLayout();
  return isMobile ? <MobileOrdersPage /> : <Dashboard />;
}
